export default "<app-issue-category-list>Loading ...</app-issue-category-list>\n"